import React, { Component } from 'react';

import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../../api/apiUtil.jsx";

import { 
  Box,
  Grid,
} from '@material-ui/core';

import CustomInput from '../../../components/CustomFields/CustomInput.jsx';
import CustomButton from '../../../components/CustomFields/CustomButton.jsx';

export class DepartmentPICForm extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let isLoading = ((props.isLoading === true || props.isLoading === false) ? props.isLoading : false);
    let item = (props.item) ? props.item : null;
    
    let drop_off_name = (item && item.drop_off_name) ? item.drop_off_name : '';
    let notification_email = (item && item.notification_email) ? item.notification_email : '';
    let drop_off_contact_no = (item && item.drop_off_contact_no) ? item.drop_off_contact_no : '';
    
    this.state = {
        isLoading: isLoading,
        item: item,

        drop_off_name: drop_off_name,
        drop_off_nameValidated: false,
        notification_email: notification_email,
        notification_emailValidated: false,
        drop_off_contact_no: drop_off_contact_no,
        drop_off_contact_noValidated: false,
    }
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading !== this.state.isLoading) {
        let isLoading = ((nextProps.isLoading === true || nextProps.isLoading === false) ? nextProps.isLoading : false);
        this.setState({
            isLoading: isLoading
        });
    }
    if (nextProps.item !== this.state.item) {
        let item = (nextProps.item) ? nextProps.item : null;
        this.setState({
            item: item
        });
    }
  }


  /* FORM */
  setForm = () => {
    return <Box>
        <Grid container>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Name'}
                        placeholder={'Name'}
                        value={this.state.drop_off_name}
                        error={this.state.drop_off_nameValidated}
                        required={true}
                        autoFocus={true}
                        onChange={(e) => {
                            this.setState({
                                drop_off_name: e.target.value,
                                drop_off_nameValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Email'}
                        placeholder={'Email'}
                        type={'email'}
                        value={this.state.notification_email}
                        error={this.state.notification_emailValidated}
                        required={true}
                        onChange={(e) => {
                            this.setState({
                                notification_email: e.target.value,
                                notification_emailValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Phone No.'}
                        placeholder={'Phone No.'}
                        value={this.state.drop_off_contact_no}
                        error={this.state.drop_off_contact_noValidated}
                        required={true}
                        onChange={(e) => {
                            this.setState({
                               drop_off_contact_no: e.target.value,
                               drop_off_contact_noValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  
  setButtons = () => {
    return <Box>
        <Grid container alignItems={'center'} >
            <Box clone textAlign={'right'} pr={2}>
                <Grid item xs={true}>
                    <CustomButton 
                        onClick={() => {
                            if(this.props.onClose){
                                this.props.onClose();
                            }
                        }}
                    >
                        Cancel
                    </CustomButton>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={'auto'}>
                    <CustomButton 
                        type={'submit'}
                        color={'secondary'} 
                        isLoading={this.state.isLoading}
                    >
                        {(this.state.item ? 'Save' : 'Save')}
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  /* END FORM */


  /* SUBMIT */
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
        isLoading: true,
    });

    const form = e.currentTarget;

    this.setState({
        drop_off_nameValidated: false,
        quantityValidated: false,
        uomValidated: false,
    });
    
    if(this.state.drop_off_name === ''){
      this.setState({
        drop_off_nameValidated: true
      });
    }
    if(this.state.notification_email === ''){
      this.setState({
        notification_emailValidated: true
      });
    }
    if(this.state.drop_off_contact_no === ''){
      this.setState({
        drop_off_contact_noValidated: true
      });
    }

    if(this.state.notification_email !== '' && !apiUtil.emailValidation(this.state.notification_email)){
        this.setState({
            notification_emailValidated: true
        });
    }

    if (form.checkValidity() === true) {
        if(this.props.onSave){
            this.props.onSave((this.state.item ? true : false), this.getForm());
        }
    } else {
        this.setState({
            isLoading: false
        });
    }
  }

  
  getForm = () => {
    let data = {
        drop_off_name: this.state.drop_off_name,
        notification_email: this.state.notification_email,
        drop_off_contact_no: this.state.drop_off_contact_no,
    }

    return data;
  }
  /* END SUBMIT */
      
  render() {
    return <Box>
        <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container>
                <Box clone pt={2} pb={2}>
                    <Grid item xs={12}>
                        {this.setForm()}
                    </Grid>
                </Box>
                <Box clone>
                    <Grid item xs={12}>
                        {this.setButtons()}
                    </Grid>
                </Box>
            </Grid>
        </form>
    </Box>
  }
}

export default DepartmentPICForm;